import { useEffect, useState, useRef } from "react";
import { postData } from "../../ApiServices/ApiService";
import { ORG_EXPENSE_OPENING_CRUD } from "../../ApiServices/BaseURL";
import { logFrontendException } from "../../Utils/Exception";
import { useTheme } from "../../GlobalContext/GlobalContext";

const ExpenseOpeningBalanceController = (expenseOpeningInfo, onRefresh, expenseOpeningInfoError) => {
    const [expenseSettingsData, setExpenseSettingsData] = useState(expenseOpeningInfo);
    const [expenseOpeningBal, setExpenseOpeningBal] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [openingBalanceAddError, setOpeningBalanceAddError] = useState("");
    const [openingBalanceAddSuccess, setOpeningBalanceAddSuccess] = useState("");
    const [openingBalanceAddLoading, setOpeningBalanceAddLoading] = useState(false);
    const [expenseOpeningBalError, setExpenseOpeningBalError] = useState("");
    const { setIsLoginPopup } = useTheme();
    const pageName = "ExpenseOpeningBalanceController"
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    useEffect(() => {
        console.log('useeffect expenseOpeningInfo', expenseOpeningInfo);
        setExpenseSettingsData(expenseOpeningInfo);

        if (
            expenseOpeningInfo?.exp_open_balance === null ||
            expenseOpeningInfo?.exp_open_balance === undefined ||
            expenseOpeningInfo?.exp_open_balance === "" ||
            expenseOpeningInfo?.exp_open_balance < 0 ||

            isNaN(Number(expenseOpeningInfo?.exp_open_balance))
        ) {
            setIsEditing(true); // Enter "add mode" if balance is missing
        } else {
            setIsEditing(false); // Balance exists
        }
        setOpeningBalanceAddError(expenseOpeningInfoError || '');
    }, [expenseOpeningInfo, expenseOpeningInfoError]);

    const handleInputChange = (value) => {
        console.log('handleInputChange value', value);
        setOpeningBalanceAddError('');
        // Validate for negative or non-number
        if (isNaN(value) || value < 0) {
            setExpenseOpeningBalError("Only positive numbers or zero are allowedff");
            setExpenseSettingsData((prev) => ({
                ...prev,
                exp_open_balance: value
            }));
        } else {
            setExpenseOpeningBalError("");  // clear error
            setExpenseSettingsData((prev) => ({
                ...prev,
                exp_open_balance: value
            }));
        }
    }

    const handleAddOpeningBalance = async () => {
        try {
            console.log('handleAddOpeningBalance', expenseSettingsData?.exp_open_balance)
            setIsEditing(true);
            setExpenseOpeningBalError('');
            setOpeningBalanceAddSuccess('');
            setOpeningBalanceAddError('');

            const value = expenseSettingsData?.exp_open_balance

            if (!value) {
                setExpenseOpeningBalError("Books Opening Balance is required.");
                return;
            }

            if (isNaN(value) || parseFloat(value) < 0) {
                setExpenseOpeningBalError("Only positive numbers or zero are allowed");
                return;
            }



            setOpeningBalanceAddLoading(true);

            // Retrieve user information (e.g., emp_id)
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Constructing payload for the API call
            const payload = {
                "action_type": "add_expense_opening_bal",
                "emp_id_auth": storedUserInfo?.emp_id,
                "exp_open_balance": expenseSettingsData?.exp_open_balance
            };

            console.log('Payload for Exp Opening Configuration:', payload);

            // Make the API call
            const response = await postData(ORG_EXPENSE_OPENING_CRUD, payload);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setOpeningBalanceAddSuccess(responseData?.info || 'Books opening balance added successfully.')
                        setTimeout(() => {
                            onRefresh();
                            setIsEditing(false);
                            // clearFields();
                            setOpeningBalanceAddSuccess('')
                        }, 3000);
                    } else {
                        setOpeningBalanceAddError(responseData?.info || 'Failed to add books opening balance.');
                        logFrontendException(storedUserId, pageName, "handleAddOpeningBalance", responseData?.info || '');
                    }
                } else {
                    setOpeningBalanceAddError(responseData?.info || 'Error while adding books opening balance.');
                    logFrontendException(storedUserId, pageName, "handleAddOpeningBalance", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setOpeningBalanceAddError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserId, pageName, "handleAddOpeningBalance", responseData || '');
                setIsLoginPopup(true)
            } else {
                setOpeningBalanceAddError('Failed to adding books opening balance. Please try again.');
                logFrontendException(storedUserId, pageName, "handleAddOpeningBalance", response || '');
            }
        } catch (error) {
            setOpeningBalanceAddError(`Failed to adding books opening balance. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "handleAddOpeningBalance", error || '');
        } finally {
            setOpeningBalanceAddLoading(false);
        }
    };

    return {
        expenseSettingsData,
        expenseOpeningBal, setExpenseOpeningBal,
        expenseOpeningBalError,
        openingBalanceAddLoading,
        openingBalanceAddError,
        openingBalanceAddSuccess,
        isEditing,
        setIsEditing,
        handleInputChange,
        handleAddOpeningBalance
    }

}




export default ExpenseOpeningBalanceController;